import styled, { css } from 'styled-components';

export const Wrap = styled.div`
  box-sizing: border-box;
  height: 240px;
  position: fixed;
  bottom: -240px;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #37373b;
  padding-bottom: 10px;
  transition: transform 0.5s;
  transform: translateY(${(props) => (props.view ? `-240px` : `0`)});
`;

export const Header = styled.div`
  position: relative;
  padding: 20px 15px 12px;
  > h2 {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    line-height: 16px;
    margin-bottom: 10px;
  }
  > p {
    color: rgba(255, 255, 255, 0.2);
    font-size: 11px;
    line-height: 10px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  :before {
    content: '';
    display: block;
    width: 18px;
    height: 18px;
    background: url(/images/sp_layout.png) no-repeat -50px 0;
    background-size: 350px 350px;
  }
`;

export const SubmitButton = styled.button`
  height: 44px;
  width: calc(100% - 10px);
  background-color: #fff;
  border-radius: 5px;
  margin: 10px 5px 0;
  font-size: 15px;
  color: #111;
  font-weight: bold;
  ${(props) =>
    props.isActive &&
    css`
      background-color: #ffca28;
    `}
`;

export const InputWrap = styled.div`
  overflow: hidden;
  border-radius: 5px;
  width: calc(100% - 10px);
  margin: 0 5px;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  padding: 0 15px;
  height: 56px;
  background-color: #f5a0c1;
  .profile_img {
    .thumb {
      width: 28px;
      height: 28px;
      position: relative;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      :before {
        position: absolute;
        content: '';
        top: 0;
        left: -1px;
        width: 30px;
        height: 30px;
        z-index: 2;
      }
      > img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
      }
      .border {
        position: absolute;
        top: -1px;
        left: -1px;
        content: '';
        width: 30px;
        height: 30px;
      }
    }
  }
  > .info {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 13px;
    overflow: hidden;
    line-height: 12px;
    .nick {
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 7px;
    }
    > p {
      font-size: 12px;
    }
  }
`;

export const Input = styled.input`
  background-color: #f26a94;
  color: #fff;
  height: 48px;
  width: 100%;
  outline: none;
  border: none;
  font-size: 14px;
  padding: 15px;
  ::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
`;
